module.exports = __webpack_public_path__ + "img/20220216_153213.c089bf12.jpg";